export default {"width":2006,"height":1209};